import { createContext } from 'react';

import { DeviceInformation } from '@hooks/use-element';
import { Db } from '@services/db';
import { KV } from '@services/kv';
import InMemoryKV from '@services/kv/InMemoryKV';
import {
	defaultQueryClient,
	QueryRequest,
} from '@services/query-client/QueryClient';
import { getGraphQLClient } from './views/home/auth/Authentication.hooks';

export const AppContext = createContext<AppContextProps>({
	appKey: '',
	lang: '',
	languages: [],
	onLanguageChange: () => {},
	onlineStatus: true,
	device: null,
	isPrinting: false,
	isInstalled: false,
	isSupportInstallPrompt: typeof window.onbeforeinstallprompt === 'object',
	isTouchable: window.matchMedia('(pointer: coarse)').matches,
	kv: new InMemoryKV(),
	baseUrl: '',
	parseGraphQLClientError: () => new Error(''),
	queryRequest: new QueryRequest(defaultQueryClient, getGraphQLClient()),
});

interface AppContextProps {
	appKey: string;
	lang: string;
	device: DeviceInformation | null;
	languages: Array<any>;
	onLanguageChange: Function;
	isTouchable: boolean;
	onlineStatus: boolean;
	isPrinting: boolean;
	db?: Db;
	isInstalled: boolean;
	isSupportInstallPrompt: boolean;
	deferredPrompt?: any;
	kv: KV;
	baseUrl: string;
	clearCache?: Promise<void>;
	parseGraphQLClientError: (err: any) => Error;
	queryRequest: QueryRequest;
}
